import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import Highlighter from "react-highlight-words";
import { Col, Flex, Skeleton } from "antd";
import { Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Typography } from 'antd';

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import type { TableProps } from "antd/es/table";
import type { ColumnType, ColumnsType } from "antd/es/table";
import { Button, Input, Space, Table } from "antd";
import type { InputRef } from "antd";
import type { FilterConfirmProps } from "antd/es/table/interface";
import { Dropdown, Form, Modal, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SettingsIcon from "@mui/icons-material/Settings";
import type { MenuProps } from "antd";


import axios from "axios";

import Globais, { validateToken } from "../../components/Globais";



const Container = styled.section`
  width: 100%;
  height: 100%;

  display: grid;
  grid-template: 10% 90% / 100%;
`;
const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: grid;

  justify-content: center;
  align-items: center;
`;
const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;
  grid-template: 10% 89% / auto;
`;

const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

const ContainerAdicionarEstado = styled.section`
  width: 100%;
  height: 100%;
  grid-column-start: 3;
 
  display: flex;

  justify-content: center;
  align-items: center;
`;


const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;
 
  

  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  display: flex;
  justify-self: flex-end;
  cursor: pointer;
  border: none;
  background-color: transparent;
`;
const ContainerImagem = styled.img`
 
`;

const defaultEstadoData = {
  nome: "",
  abreviacao: "",
  origem: 0,
  paisId: 0,
};

interface DataType {
  id: number;
  nome: string;
  abreviacao:string;
  paisId: string;
  origem: string;
}
interface ValuesMaisEstado {
  nome: string;
  abreviacao: string;
}

interface ValuesEditarEstado {
  nome: string;
  abreviacao: string;
}

type DataIndex = keyof DataType;
type MenuItem = Required<MenuProps>["items"][number];

interface CollectionCreateFormPropsMaisEstado {
  open: boolean;
  onCreate: (valuesMaisPeriodo: ValuesMaisEstado) => void;
  onCancel: () => void;
}

export default function ViewGerenciarEstado() {
  const [isModalInserirEstadoVisible, setIsModalInserirEstadoVisible] =
    useState(false);
    const [Estado, setEstado] = useState<any>();
    const { Title } = Typography;
    const searchInput = useRef<InputRef>(null);
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const [messageApi, contextHolder] = message.useMessage();
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const emLote = useRef(0);
    const [openMaisEstado, setOpenMaisEstado] = useState(false);
    const [ openEditarEstado, setOpenEditarEstado] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [tipo, setTipo] = useState(0);
    const [status, setStatus] = useState<number>(0);
    const [texto, setTexto] = useState<string>("");
    const [estadoFormData, setEstadoFormData] = useState(defaultEstadoData);
    estadoFormData.paisId = 2;
    const estado = useRef(0);
    const infoEstado = useRef('');
    const nomeEstado = useRef('');
    const [openExcluir, setOpenExcluir] = useState(false);



    const onSubmit = async (event: React.FormEvent) => {

    event.preventDefault();

    if (window.navigator.onLine === false) {
      setStatus(3);
      setTexto("Parece que você está sem conexão com a internet!");
      setTimeout(() => {
        setStatus(0);
      }, 3000);
    } else {
      const Token = validateToken();
      if (Token) {
        if (Token.nda === 1) {
          try {
            const URL = `${Globais.DOMINIOBACK}/estado`;

            const response = await axios.post(URL, estadoFormData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              setStatus(1);

              setTexto("Estado incluído com sucesso!");
            }

            setTimeout(() => {
              document.location.href = "/gerenciarEstado";
            }, 2000);
          } catch (error) {
            switch (error.code) {
              case "ERR_NETWORK":
                setStatus(2);
                setTexto("Parece que tem algo errado com nosso serviço!");
                setTimeout(() => {
                  setStatus(0);
                }, 3000);
                break;
            }
          }
        } else {
          document.location.href = "/";
        }
      } else {
        document.location.href = "/";
      }
    }
  };

  const CollectionCreateFormMaisEstado: React.FC<
  CollectionCreateFormPropsMaisEstado
> = ({ open, onCreate, onCancel }) => {
  const [form] = Form.useForm();
  return (
    <Modal
      open={openMaisEstado}
      title="Adicionar estado"
      okText="Adicionar"
      cancelText="Cancelar"
      onCancel={onCancel}
      width={300}
      onOk={() => {
        form
          .validateFields()
          .then((valuesMaisEstado) => {
            form.resetFields();
            onCreate(valuesMaisEstado);
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        // name="form_in_modal"
        // initialValues={{ modifier: "public" }}
      >

        <Row gutter={16}>
          <Form.Item
            name="nome"
            label="Estado"
            style={{ width: 400 }}
          >
            <TextArea size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
        <Row gutter={16}>
          <Form.Item
            name="abreviacao"
            label="Sigla"
            style={{ width: 400 }}
          >
            <TextArea size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
};

  const CollectionCreateFormEditarEstado: React.FC<
    CollectionCreateFormPropsMaisEstado
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openEditarEstado}
        title="Editar estado"
        okText="Editar"
        cancelText="Cancelar"
        onCancel={onCancel}
        width={300}
        onOk={() => {
          form
            .validateFields()
            .then((ValuesMaisEstado) => {
              form.resetFields();
              onCreate(ValuesMaisEstado);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
          <Form.Item
            name="nome"
            label="Estado"
            style={{ width: 400 }}
          >
            <TextArea
            defaultValue={nomeEstado.current}
            size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
        <Row gutter={16}>
          <Form.Item
            name="abreviacao"
            label="Sigla"
            style={{ width: 400 }}
          >
            <TextArea
            defaultValue={infoEstado.current}
            size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
        </Form>
      </Modal>
    );
  };

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };
  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };
  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const hideModal = () => {
    setOpenExcluir(false);
  };
  const showModal = () => {
     alert("FUNÇÃO EM DESENVOLVIMENTO.");
  };

  const excluirEstado = async () => {
    const Token = validateToken();
   
  };


  const adicionarEstados = async (valuesMaisEstado: any) => {
    const Token = validateToken();
    if (Token) {
      const URLEstado = `${Globais.DOMINIOBACK}/estado`;
      let estadoFormData = {
        nome: valuesMaisEstado.nome,
        abreviacao: valuesMaisEstado.abreviacao,

        paisId: 2,
        origem: 0,
      };
      try {
        const responseCriarEstado1 = await axios.post(
          URLEstado,
          estadoFormData,
          {
            headers: { Authorization: Token.AuthStr },
          }
        ); 
        if (responseCriarEstado1) {
          success("Estado adicionado com sucesso!");
          setTimeout(() => {
            document.location.reload();
          }, 2000);
        }
      }
      catch (error) {
        console.log("Não foi possível criar o estado");
        error("Algo deu errado!");
      }
    } else {
      error("Favor fazer login novamente!.");
      document.location.reload();
    }
  }
  
  const editarEstados = async (valuesMaisEstado: any) => {
   const Token = validateToken();
    
   if (Token) {
    const URLChecarEstado = `${Globais.DOMINIOBACK}/estado/${estado.current}`;

    try {
      const responseEstado = await axios.get(URLChecarEstado, {
        headers: {
          Authorization: Token.AuthStr
        },
      });
      
      if (responseEstado) {
        if (responseEstado.data) {
          const URLEstado = `${Globais.DOMINIOBACK}/estado/${estado.current}`;
          let estadoFormData = {
            id: estado.current,
            nome: valuesMaisEstado.nome,
            abreviacao: valuesMaisEstado.abreviacao,

            paisId: 2,
            origem: 0,
          }; console.log(estadoFormData);

          try {
            const responseCriarEstado1 = await axios.put(URLEstado,
              estadoFormData,
              {
                headers: {
                  Authorization: Token.AuthStr
                },
              });

              if (responseCriarEstado1) {
                success("Estado editado com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              }
          } catch (error) {
            console.log("Não foi possível editar o estado.");
            error("Algo deu errado!");
          }
        } 
      }
    } catch (error){
      error("Algo deu errado.");
    }
   } else {
    error("Favor fazer login novamente!.");
    document.location.reload();
   }
  };
  
  
  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      if (Token) {
        if(Token.nda === 0){
          document.location.href = "/sempermissao";
        }else{
          const URL = `${Globais.DOMINIOBACK}/estado`;
          try {
            const response = await axios.get(URL, {
              headers: { Authorization: Token.AuthStr },
            });
  
            if (response) {
              let ArrayNovo = response.data.filter((p: any) => {
                p.id = p.id;
                p.nome = p.nome;
                p.abreviacao = p.abreviacao;
                if(p.origem === 0){
                  p.origem = "Multicotas";
                }else{
                  p.origem = "Usuário";
                }
                return p;
              });
  
              setEstado(ArrayNovo);
              setIsLoading(false);
            }
          } catch (error) {
            // if (error.response.status === 401) {
            //   logout();
            // }
          }
        }
       
      }
    };
    fetchToken();
  }, []);

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined  />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined
        style={{ color: filtered ? "#1677ff" : undefined }}
        
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }


  const items: MenuProps["items"] = [
    { key: "2", label: "Editar" },
    { key: "1", label: "Excluir" },
    
  ];

  const onClick: MenuProps["onClick"] = async ({ key }) => {
    const Token = validateToken();
    const perfil = Token?.nda;

    // const situacao = active.current;
  
    if (
      selectedRowKeys.length === 0 &&
      emLote.current === 1
    ) {
      error("Selecione um item!");
    } else {
      switch (key) {
        case "1":
          showModal();

          break;
        case "2":
          setOpenEditarEstado(true);
      }
    }
  };

  const handleAdd = () => {
    setOpenMaisEstado(true);
  };

  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Estado",
      dataIndex: "nome",
      key: "nome",
      width: "20%",
      align: "center",

      ...getColumnSearchProps("nome"),
    },
    {
      title: "Sigla",
      dataIndex: "abreviacao",
      key: "abrevicao",
      width: "20%",
      align: "center",

      ...getColumnSearchProps("abreviacao"),
    },
    {
      title: "Origem",
      dataIndex: "origem",
      key: "origem",
      width: "20%",
      align: "center",
      defaultFilteredValue: ["Multicotas"],

      filters: [
        { text: "Multicotas", value: "Multicotas" },
        { text: "Usuário", value: "Usuario" },
        
      ],
      onFilter: (value: any, record) => record.origem.includes(value),
      filterSearch: true,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "20%",
      align: "center",

      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                estado.current = row.id;
                nomeEstado.current = row.nome;
                infoEstado.current = row.abreviacao;

              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Container>

        <Row>
          {contextHolder}
          <Col span={3}> 
          
         
        
             
          </Col>
          <Col span={18}>
            <Flex align="center" justify="center">
                <Title style={{color:`${Globais.CorAzulBackGround}`}} level={4}>Gerenciar Estados</Title>
            </Flex>
          
          </Col>
          <Col span={3}>
          <ContainerAdicionarEstado>
              <Button
                onClick={handleAdd}
                type="primary"
                style={{ marginBottom: 16, alignSelf: "left" }}
              >
                + Estado
              </Button>
            </ContainerAdicionarEstado>
          </Col>
          
         
              
         
         

        </Row>
        <ContainerLista>
        <CollectionCreateFormMaisEstado
              open={openMaisEstado}
              onCreate={async function (
                valuesMaisEstado: ValuesMaisEstado
              ): Promise<void> {
                adicionarEstados(valuesMaisEstado);
              }}
              onCancel={function (): void {
                setOpenMaisEstado(false);
              }}
            />
      
          <Table
            columns={columns}
            dataSource={Estado}
            onChange={onChange}
            bordered
          />

        <CollectionCreateFormEditarEstado
              open={openEditarEstado}
              onCreate={async function (
                ValuesMaisEstado: ValuesMaisEstado
              ): Promise<void> {
                editarEstados(ValuesMaisEstado);
              }}
              onCancel={function (): void {
                setOpenEditarEstado(false);
              }}
            />
              <Modal
              title="Tem certeza que deseja excluir?"
              open={openExcluir}
              onOk={excluirEstado}
              onCancel={hideModal}
              okText="Sim, quero excluir"
              cancelText="Não"
            >
              <p>
                Essa ação não poderá ser desfeita. Será necessário criar outro
                período.
              </p>
            </Modal>
        </ContainerLista>
      </Container>
      )}
    </>
  );
}
